import {V1ETLGoogleConfigurationDetailIDOCToArray} from "../../../../util/Payload";
import EnterpriseComponent from "../../EnterpriseComponent";
import EnlilAxios from "../../../../util/EnlilAxios";

class ETLGoogleConfigurationDetailEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        EnlilAxios({
            method: "GET",
            url: "t1/v1/etl_google_configuration_details",
            json: true,
            params: {
                "Limit": pageSize,
                "ETLGoogleConfigurationUSID": foreignKey
            },
            headers: {
                "idoc-response": this.getIDOCResponse() ?? "v1.ETLGoogleConfigurationDetail-001",
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1ETLGoogleConfigurationDetailIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };

}

export default ETLGoogleConfigurationDetailEnterpriseComponent;